import { primaryColor, theme } from "../../../utils/theme";
import { Box, TextField, FormControl, Stepper, Button, Typography } from "@mui/material";
import styled from "styled-components";

export const PageContainer = styled(Box)({
  minHeight: '100vh',
  display: 'flex',
});

export const HeroPanel = styled(Box)(({ theme }) => ({
  width: '50%',
  position: 'relative',
  display: 'none',
  [theme.breakpoints.up('lg')]: {
    display: 'flex',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background: `linear-gradient(135deg, ${theme.palette.primary.main}66, ${theme.palette.primary.main}33)`,
    zIndex: 1,
  },
}));

export const HeroImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

export const HeroBranding = styled(Box)({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 2,
  color: `${theme.palette.white.main} !important`,
  textAlign: 'center',
});

export const LogoCircle = styled(Box)(({ theme }) => ({
  width: 80,
  height: 80,
  borderRadius: '50%',
  backgroundColor: 'rgba(255, 255, 255, 0.2)',
  backdropFilter: 'blur(8px)',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
}));

export const FormPanel = styled(Box)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    width: '50%',
  },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  backgroundColor: `${theme.palette.background.default} !important`,
}));

export const FormContainer = styled(Box)({
  width: '100%',
  maxWidth: 600,
});

export const StyledTextField = styled(TextField)(({ theme, error }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.white.main,
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.error.main,
    },
  },
}));

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.white.main,
  },
}));

export const StyledStepper = styled(Stepper)(({ theme }) => ({
  "& .MuiStepIcon-root": {
      width: 28,
      height: 28,
      borderRadius: `${theme.spacing(1)} !important`, 
      background: theme.palette.grey[200],
      color: theme.palette.grey[200],
    },
    "& .Mui-active .MuiStepIcon-root": {
      backgroundColor: primaryColor,
       ".MuiStepIcon-text": {
        color: `${theme.palette.white.main} !important`,
        fill: `${theme.palette.white.main} !important`
      },
    },
    "& .Mui-completed .MuiStepIcon-root": {
      backgroundColor: primaryColor,
    },
    ".MuiStepIcon-text": {
      color: `${primaryColor} !important`,
      fill: `${primaryColor} !important`
    },
}));

export const RequiredAsterisk = styled('span')(({ theme }) => ({
  color: theme.palette.error.main,
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  height: 48,
  fontSize: 16,
  fontWeight: 500,
  marginTop: `${theme.spacing(4)} !important`,
}));

export const FormBox = styled('form')(({theme}) => ({
  marginTop: `${theme.spacing(4)} !important`,
  background: theme.palette.white.main,
  padding: `${theme.spacing(4)} !important`,
  borderRadius: `${theme.spacing(1)} !important`
}));

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: '0.75rem',
  marginTop: theme.spacing(1),
}));